var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRodicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "14.1px",
    viewBox: "0 0 100 14.1",
    enableBackground: "new 0 0 100 14.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 3.1,
    fill: "#FFFFFF",
    stroke: "#474646",
    width: 82.6,
    height: 4.9
  })), /*#__PURE__*/React.createElement("rect", {
    x: 91.2,
    y: 3.7,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 0.8167,
    width: 7.8,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 1.7,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 1.0132,
    width: 12,
    height: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 1.7,
    fill: "#FFFFFF",
    stroke: "#474646",
    strokeWidth: 1.0132,
    width: 12,
    height: 7.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRodicon);
export default __webpack_public_path__ + "static/media/Rodicon.0f412de05c59fe2ff5dba65fdb5232e4.svg";
export { ForwardRef as ReactComponent };